module.exports = __webpack_public_path__ + "img/pab.785d3584.png";